// Lit + the shared SPA primitives, re-exported from the single vendored d3-kit
// bundle. d3-kit owns the Lit copy (it bundles Lit in and re-exports it), so the
// portal imports `LitElement`, `html`, `css`, … from here rather than vendoring
// its own — guaranteeing one Lit on the page.
//
// The re-export comes through the BARE `@dice-driven/d3-kit` specifier, not a
// relative path: Bun keeps it external (see build.js / dev-server.js) and
// index.html's import map resolves it to the standalone-served
// /vendor/d3-kit/d3-kit-<ver>.min.js. The versioned filename therefore lives in
// that import map, which is the one place to edit when bumping d3-kit.
export {
    authState,
    BaseComponent,
    css,
    getBootstrapIconsStyles,
    getBootstrapStyles,
    html,
    LitElement,
    nothing,
    Router,
    renderMarkdown,
    svg,
    unsafeCSS,
} from '@dice-driven/d3-kit';
